import {API_ENDPOINTS} from "../constants";

import {API_URL} from "../config";
import {postDataWithSession} from "./index";

const fakeFetch = (data = {}, shouldReject = false, time = 500) =>
  new Promise((resolve, reject) => {
    setTimeout(() => shouldReject ? reject(data) : resolve(data), time);
  });

const SCHOOLS = [
  {
    atp_code: 123456,
    name: 'Test School',
    city: 'Testville',
    batch_type: 'A'
  },
  {
    atp_code: 234567,
    name: 'West School',
    city: 'Testville',
    batch_type: 'M'
  },
  {
    atp_code: 345678,
    name: 'East School',
    city: 'Testville',
    batch_type: 'M'
  }
]

export const getDistrictSchools = (district, queryParams) => {
  const options = {
    body: JSON.stringify(district)
  };

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.GET_SCHOOLS}`, options, true);
}

export const updateSchoolBatchType = (queryParams, schools) => {
  const options = {
    body: JSON.stringify(schools)
  };

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.UPDATE_SCHOOL_BATCH_TYPE}`, options);
}

export const createNewSchool = (queryParams, schoolComposite) => {
  const options = {
    body: JSON.stringify(schoolComposite)
  };

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.CREATE_NEW_SCHOOL}`, options);
}

export const getSchoolDemographic = (queryParams) => {
  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.GET_SCHOOL_DEMOGRAPHIC}`, {});
}

export const getStatus = (queryParams) => {
  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.GET_STATUS}`, {});
}

export const getStatusList = (queryParams) => {
  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.GET_STATUS_LIST}`, {}, true);
}